import api, { unwrap } from './client';
import { opsViaSop } from './opsRoute';

// Le rôle Opérations passe par `/api/sop/budget` (mêmes fonctions serveur).
const base = () => (opsViaSop() ? '/sop/budget' : '/financials/budget');

/* Budget des charges (2026-09-28) — une ligne par charge prévue. Le calcul
   (charge du mois, total, paiements) vit au SERVEUR : ici, rien que des appels. */
export const getBudget = (tenantId, year) =>
  unwrap(api.get(`${base()}/${tenantId}`, { params: { year } }));

export const createBudgetLine = (tenantId, payload) =>
  unwrap(api.post(`${base()}/${tenantId}`, payload));

export const patchBudgetLine = (tenantId, lineId, payload) =>
  unwrap(api.patch(`${base()}/${tenantId}/${lineId}`, payload));

export const deleteBudgetLine = (tenantId, lineId) =>
  unwrap(api.delete(`${base()}/${tenantId}/${lineId}`));

// Une ligne pour chaque compte des autres charges qui n'en a pas encore.
export const loadBudgetAccounts = (tenantId, year) =>
  unwrap(api.post(`${base()}/${tenantId}/load-accounts`, { year }));

// Remplace les lignes de `toYear` par une copie de celles de `fromYear`.
export const copyBudgetYear = (tenantId, fromYear, toYear) =>
  unwrap(api.post(`${base()}/${tenantId}/copy`, { from_year: fromYear, to_year: toYear }));

export const clearBudgetYear = (tenantId, year) =>
  unwrap(api.post(`${base()}/${tenantId}/clear`, { year }));
